import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

import { MediaService } from "../../../common/media.service";
import { ToastrService } from "ngx-toastr";
import { CdkDragDrop } from "@angular/cdk/drag-drop";

@Component({
  selector: "app-sub-folders",
  templateUrl: "./sub-folders.component.html",
  styleUrls: ["./sub-folders.component.css"],
})
export class SubFoldersComponent implements OnInit {
  @Input() childs;
  @Input() isMove = false;
  @Input() selectedFolders
  @Input() switchCase
@Input() isDragging
@Input() connectedIds: string[] = [];
  // @Input() fromMoveDialog = false;
  constructor(
    private mediaManagerService: MediaService,
    private snotifyService: ToastrService,
  ) {}
  folderSelected
  openedParentFolders = new Map();

  ngOnInit() {
 
console.log("a",this.selectedFolders)
console.log(this.childs.items)

  }

  getSubItems(folder,event) {
    event.stopPropagation();
    if (folder.id == this.mediaManagerService.folder.parentId) {
      this.mediaManagerService.folder = {};
      // this.returnSearchToDefault();
      this.search();

      return;
    }

    if (this.isMove) {
      {
        this.mediaManagerService.isParentIdChanged(
          folder.id,
          folder.name,
          folder.parentFolderId,
          folder.mediaCount,
          folder.currentFolderBreadcrumb
        );
      }

      return;
    }

    if (folder.id != this.mediaManagerService.folder.parentId) {
      this.mediaManagerService
        .searchMediaAndFolders(folder.id)
        .subscribe((res: any) => {
          this.mediaManagerService.isParentIdChanged(
            res.currentFolderId,
            res.currentFolderName,
            res.parentFolderId,
            res.media.length,
            res.currentFolderBreadcrumb
          );
        });
    }
  }
  drop(event, folderId) {
    var drag = [];
    drag.push(event.dragData.toString());
    this.mediaManagerService
      .moveMedia(drag, folderId)
      .subscribe((res: any) => {
        this.openNotifySuccess("Media successfully moved.");
        
        this.mediaManagerService.getFoldersFirstTime();
        this.mediaManagerService.getAllSideFolders();

      });
  }
  

    public dropFromFolder(event: CdkDragDrop<any>,folderId,isMedia?): void {
      // let folderId = event.item.data.folderId
      // Instead of event.dragData, use event.item.data from CDK
      if(isMedia){
        return
      }
      const draggedItemId = event.item.data.folderId;
      console.log('Dragged Item ID:', draggedItemId);
      
      let isFolder = false;
    
      // Check if the dragged item is among your folder list
      if (this.childs.items && this.childs.items.length > 0) {
        this.childs.items.forEach((element) => {
          if (element.id == draggedItemId) {
            console.log("It is a folder");
            isFolder = true;
          }
        });
      }
    
      if (isFolder) {
        // If it's a folder, perform your folder-moving logic
        this.moveFolders(draggedItemId, folderId);
      } else {
        // Otherwise, assume it's a media item and call your service
        this.mediaManagerService
          .moveMedia([draggedItemId], folderId || 0)
          .subscribe((res: any) => {
            // this.getSbreadCrumb(null);
            this.openNotifySuccess("Media successfully moved.");
    
            // Update your local or global folder data
            this.mediaManagerService.getFoldersFirstTime();
            this.mediaManagerService.folder$.subscribe();
            this.mediaManagerService.getAllSideFolders();
          });
      }
    }
    moveFolders(current, parent) {
      this.mediaManagerService
        .moveFolders([current], parent)
        .subscribe(() => {
          this.openNotifySuccess("Successfully moving");
          // this.getSbreadCrumb(null);
          this.mediaManagerService.getFoldersFirstTime();
          this.mediaManagerService.getAllSideFolders();
        });
    }
  openSubFolder(event, folder) {
       event.stopPropagation();
    if (this.openedParentFolders.get(folder.id))
      this.openedParentFolders.delete(folder.id);
    else this.openedParentFolders.set(folder.id, folder);
  }
  public openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  search() {
    this.mediaManagerService
      .searchMediaAndFolders()
      .subscribe((res: any) => {});
  }
}
